import appsApi from "./admin.api";
import utils from "@/helpers/utilidades";

export default {
    /**
     *
     * @param aplicacion
     * @returns {Promise<AxiosResponse<any>>}
     */
    index(aplicacion) {
        return appsApi.api.get(utils.url_options(`${appsApi.baseURL}/aplicacion/${aplicacion}/modulos`));
    },

    modulos_roles(aplicacion) {
        return appsApi.api.get(utils.url_options(`${appsApi.baseURL}/aplicacion/${aplicacion}/modulos/modulos_roles`));
    }

    ,modulo(aplicacion,modulo) {
        return appsApi.api.get(utils.url_options(`${appsApi.baseURL}/aplicacion/${aplicacion}/modulos/${modulo}`));
    },

    crear(aplicacion,payload) {
        return appsApi.api.post(`${appsApi.baseURL}/aplicacion/${aplicacion}/modulos`, payload)
    },

    editar(aplicacion, modulo, payload) {
        return appsApi.api.put(`${appsApi.baseURL}/aplicacion/${aplicacion}/modulos/${modulo}`, payload)
    },

    eliminar(aplicacion, modulo) {
        return appsApi.api.delete(`${appsApi.baseURL}/aplicacion/${aplicacion}/modulos/${modulo}`)
    },

}
